@switch (validator) {
  @case ("pattern") {
    @if (question && question.type === "OPENANSWER") {
      <div class="flex items-start gap-2 pl-2 pr-2 pt-2">
        <app-icon
          [name]="Icon.Warning"
          class="w-6 h-6 validation-dynamic-theme flex-shrink-0"
          [attr.aria-label]="'validation.general.error' | translate"
        ></app-icon>
        <p class="validation-dynamic-theme error-selector text-left">
          @switch (question.formatPattern) {
            @case ("EMAIL") {
              {{ "validation.inline.general.invalidformat.email" | translate }}
            }
            @case ("DECIMAL") {
              {{ "validation.inline.general.invalidformat.decimal" | translate }}
            }
            @case ("INTEGER") {
              {{ "validation.inline.general.invalidformat.integer" | translate }}
            }
            @case ("99.99.9999") {
              {{ "validation.inline.general.invalidformat.date" | translate }}
            }
            @case ("99:99") {
              {{
                "validation.inline.general.invalidformat.timewithoutseconds"
                  | translate
              }}
            }
            @case ("99:99:99") {
              {{
                "validation.inline.general.invalidformat.timewithseconds"
                  | translate
              }}
            }
            @case ("#") {
              {{
                "validation.inline.general.invalidformat.numbersonly" | translate
              }}
            }
            @case ("@") {
              {{
                "validation.inline.general.invalidformat.lettersonly" | translate
              }}
            }
            @case ("AAAA") {
              {{
                "validation.inline.general.invalidformat.fourletters" | translate
              }}
            }
            @case ("9999") {
              {{
                "validation.inline.general.invalidformat.fournumbers" | translate
              }}
            }
            @default {
              {{
                "validation.inline.general.invalidformat.custom"
                  | translate: { formatPattern: question.formatPattern }
              }}
            }
          }
        </p>
      </div>
    }
  }
  @case ("maxLength") {
    @if (question && control) {
      <div class="flex items-start gap-2 pl-2 pr-2 pt-2">
        <app-icon
          [name]="Icon.Warning"
          class="w-6 h-6 validation-dynamic-theme flex-shrink-0"
          [attr.aria-label]="'validation.general.error' | translate"
        ></app-icon>
        <p class="validation-dynamic-theme error-selector text-left">
          {{
            "validation.inline.general.maxlength"
              | translate
                : {
                    required: control?.errors?.["maxLength"].requiredLength,
                    actual: control?.errors?.["maxLength"].actualLength,
                  }
          }}
        </p>
      </div>
    }
  }

  @case ("requiredText") {
    @if (question) {
      <div class="flex items-start gap-2 pl-2 pr-2 pt-2">
        <app-icon
          [name]="Icon.Warning"
          class="w-6 h-6 validation-dynamic-theme flex-shrink-0"
          [attr.aria-label]="'validation.general.error' | translate"
        ></app-icon>
        <p
          id="required-error"
          class="validation-dynamic-theme error-selector text-left"
        >
          {{ "validation.inline.general.requiredtext" | translate }}
        </p>
      </div>
    }
  }

  @case ("requiredSelect") {
    @if (question) {
      <div class="flex items-start gap-2 pl-2 pt-2">
        <app-icon
          [name]="Icon.Warning"
          class="w-6 h-6 validation-dynamic-theme flex-shrink-0"
          [attr.aria-label]="'validation.general.error' | translate"
        ></app-icon>
        <p
          id="required-error-{{ question.id }}"
          aria-live="assertive"
          role="alert"
          class="validation-dynamic-theme error-selector text-left"
          [ngClass]="{
            'sticky left-0 max-w-fit': multiMatrixQuestionTitle,
          }"
        >
          {{
            "validation.inline.general.requiredselect"
              | translate
                : {
                    title: multiMatrixQuestionTitle || question.title | stripHtml,
                  }
          }}
        </p>
      </div>
    }
  }
  @case ("maxSelections") {
    @if (question && question.type === "PRIORITY_DRAGDROP") {
      <div class="flex items-start gap-2 pl-2 pr-2 pt-2">
        <app-icon
          [name]="Icon.Warning"
          class="w-6 h-6 validation-dynamic-theme flex-shrink-0"
          [attr.aria-label]="'validation.general.error' | translate"
        ></app-icon>
        <p
          id="max-selection-error-{{ question.id }}"
          aria-live="assertive"
          role="alert"
          class="validation-dynamic-theme text-left"
        >
          {{
            "validation.inline.general.maxselections"
              | translate: { maxSelections: question.maxNumberOfSelections }
          }}
        </p>
      </div>
    }
  }
  @case ("incorrectPassword") {
    <div class="flex items-start gap-2 pl-2 pr-2 pt-2">
      <app-icon
        [name]="Icon.Warning"
        class="w-6 h-6 validation-dynamic-theme flex-shrink-0"
        [attr.aria-label]="'validation.general.error' | translate"
      ></app-icon>
      <p
        id="incorrect-password-error"
        class="validation-dynamic-theme text-left"
        aria-live="assertive"
        role="alert"
      >
        {{ "validation.password.incorrect" | translate }}
      </p>
    </div>
  }
  @case ("gdprConsentRequired") {
    <div class="flex items-start gap-2 pl-2 pr-2 pt-2">
      <app-icon
        [name]="Icon.Warning"
        class="w-6 h-6 validation-dynamic-theme flex-shrink-0"
        [attr.aria-label]="'validation.general.error' | translate"
      ></app-icon>
      <p
        id="incorrect-password-error"
        class="validation-dynamic-theme text-left"
        aria-live="assertive"
        role="alert"
      >
        {{ "validation.general.missingconsentanswer" | translate }}
      </p>
    </div>
  }
  @case ("missingHiddenAnswer") {
    <div class="flex items-start gap-2 pl-2 pr-2 pt-2">
      <app-icon
        [name]="Icon.Warning"
        class="w-6 h-6 validation-dynamic-theme flex-shrink-0"
        [attr.aria-label]="'validation.general.error' | translate"
      ></app-icon>
      <p
        id="incorrect-password-error"
        class="validation-dynamic-theme text-left"
        aria-live="assertive"
        role="alert"
      >
        {{ "validation.general.missinghiddenanswer" | translate }}
      </p>
    </div>
  }
  @case ("invalidEmailReceipt") {
    <div class="flex items-start gap-2 pl-2 pr-2 pt-2">
      <app-icon
        [name]="Icon.Warning"
        class="w-6 h-6 validation-dynamic-theme flex-shrink-0"
        [attr.aria-label]="'validation.general.error' | translate"
      ></app-icon>
      <p
        id="invalid-email-receipt-error"
        class="validation-dynamic-theme text-left"
        aria-live="assertive"
        role="alert"
      >
        {{ "thankyou.sendreceipt.invalidemailaddress" | translate }}
      </p>
    </div>
  }
  @case ("invalidEmailCollect") {
    <div class="flex items-start gap-2 pl-2 pr-2 pt-2">
      <app-icon
        [name]="Icon.Warning"
        class="w-6 h-6 validation-dynamic-theme flex-shrink-0"
        [attr.aria-label]="'validation.general.error' | translate"
      ></app-icon>
      <p
        id="invalid-email-collect-error"
        class="validation-dynamic-theme text-left"
        aria-live="assertive"
        role="alert"
      >
        {{ "validation.collectemail.invalidemailformat" | translate }}
      </p>
    </div>
  }
  @case ("emptyEmailCollect") {
    <div class="flex items-start gap-2 pl-2 pr-2 pt-2">
      <app-icon
        [name]="Icon.Warning"
        class="w-6 h-6 validation-dynamic-theme flex-shrink-0"
        [attr.aria-label]="'validation.general.error' | translate"
      ></app-icon>
      <p
        id="empty-email-collect-error"
        class="validation-dynamic-theme text-left"
        aria-live="assertive"
        role="alert"
      >
        {{ "information.collectemail.text" | translate }}
      </p>
    </div>
  }
  @case ("receiptHasAlreadyBeenSent") {
    <div class="flex items-start gap-2 pl-2 pr-2 pt-2">
      <app-icon
        [name]="Icon.Warning"
        class="w-6 h-6 validation-dynamic-theme flex-shrink-0"
        [attr.aria-label]="'validation.general.error' | translate"
      ></app-icon>
      <p
        id="receipt-already-sent-error"
        class="validation-dynamic-theme text-left"
        aria-live="assertive"
        role="alert"
      >
        {{ "validation.responsereceipt.receipthasalreadybeensent" | translate }}
      </p>
    </div>
  }
  @case ("QuotaError") {
    <div class="flex items-start gap-2 pl-2 pr-2 pt-2">
      <app-icon
        [name]="Icon.Warning"
        class="w-6 h-6 validation-dynamic-theme flex-shrink-0 mt-1"
        [attr.aria-label]="'validation.general.error' | translate"
      ></app-icon>
      <p
        id="quota-error-{{ question?.id }}"
        class="validation-dynamic-theme rich-text-content error-selector text-left"
        aria-live="assertive"
        role="alert"
      >
        <span
          class="block mt-1 font-semibold text-lg"
          [innerHTML]="control?.errors?.['QuotaError']?.message | safeHtml"
        ></span>
        @if (alternativeTitle) {
          <span class="text-sm">{{
            "validation.quota.alternativereached"
              | translate
                : {
                    alternativeTitle: alternativeTitle | stripHtml,
                  }
          }}</span>
        }
      </p>
    </div>
  }
}
